export const languages = {
  en: 'English',
  nl: 'Nederlands',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  da: 'Danish',
  ar: 'Arabic',
};

export function redirectToUrl(uri: string) {
  window.location.href = uri;
}
